// extracted by mini-css-extract-plugin
module.exports = {"bp-min-sm":"(min-width: 520px)","link":"WidgetFooterLinks-module--link--48445f","linksContainer":"WidgetFooterLinks-module--linksContainer--fbee58"};